var groupBy = require('./utils/groupBy');
var supplant = require('./utils/supplant');
var countriesData = require('./countriesData');
module.exports = {
  /**
   * Returns some module utils
   */
  utils: {
    groupBy: groupBy
  },
  /**
   * Returns the list with all the countries data
   */
  all: function all() {
    return countriesData;
  },
  /**
   * Filters the list of countries and returns those matching with the filter criteria
   * @param {String} countryProperty - The property to use in the filter. Must be any of the country properties (countryCode, currencyCode, etc)
   * @param {String} value - The value to use in the filter
   */
  filter: function filter(countryProperty, value) {
    return countriesData.filter(function (countryData) {
      return countryData[countryProperty] === value;
    });
  },
  /**
   * Find a country by a property and return the first match
   * @param {String} countryProperty - The property to use in the search. Must be any of the country properties (countryCode, currencyCode, etc)
   * @param {String} value - The value to use in the filter
   */
  findOne: function findOne(countryProperty, value) {
    return countriesData.find(function (countryData) {
      return countryData[countryProperty] === value;
    });
  },
  /**
   * Returns a collection with fields mapped as requested
   * @param {*} fields - Map of fields and placeholders 
   */
  customArray: function customArray() {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      name: '{countryNameEn} ({countryCode})',
      value: '{countryCode}'
    };
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      sortBy = _ref.sortBy,
      sortDataBy = _ref.sortDataBy,
      filter = _ref.filter;
    var finalCollection = [];
    var data = countriesData;
    if (typeof filter === 'function') {
      data = data.filter(filter);
    }
    if (sortDataBy) {
      // ignore upper and lowercase
      var collator = new Intl.Collator([], {
        sensitivity: 'accent'
      });
      data.sort(function (a, b) {
        return collator.compare(a[sortDataBy], b[sortDataBy]);
      });
    }
    data.forEach(function (countryData) {
      var collectionObject = {};
      for (var field in fields) {
        collectionObject[field] = supplant(fields[field], countryData);
      }
      finalCollection.push(collectionObject);
    });
    if (sortBy && fields[sortBy]) {
      // ignore upper and lowercase
      var _collator = new Intl.Collator([], {
        sensitivity: 'accent'
      });
      finalCollection.sort(function (a, b) {
        return _collator.compare(a[sortBy], b[sortBy]);
      });
    }
    return finalCollection;
  },
  /**
   * Returns a custom object with the passed key as object key and a value made up with
   * values set in the placeholders of the label variable
   * @param {*} key - Key used to construct the object to return
   * @param {*} label - Placeholder like string, with all the fields that you want to use
   */
  customList: function customList() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'countryCode';
    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{countryNameEn} ({countryCode})';
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      filter = _ref2.filter;
    var finalObject = {};
    var data = countriesData;
    if (typeof filter === 'function') {
      data = data.filter(filter);
    }
    data.forEach(function (countryData) {
      var value = supplant(label, countryData);
      finalObject[countryData[key]] = value;
    });
    return finalObject;
  }
};